<form class="form" [ngClass]="{'text-secondary ms-2': submenu}">
  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.source' | translateHs }}:</div>
    <div class="p-1 w-75">
      <div class="input-group mb-3">
        <input class="form-control" name="hs-icon-symbolizer-image" [(ngModel)]="symbolizer.image"
          (change)="emitChange()" />
        <button class="btn btn-outline-secondary" (click)="showIconSelector()" type="button">
          ...
        </button>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{'STYLER.anchor' | translateHs }}:</div>
    <span class="badge bg-warning mt-2" [title]="'STYLER.warningAttribNotStoredNotVisualized' | translateHs  ">!</span>
    <div class="p-1 w-75">
      <select class="form-control form-select form-select-sm" [(ngModel)]="symbolizer.anchor" (change)="emitChange()"
        name="hs-icon-symbolizer-anchor">
        <option *ngFor="let anchor of anchors">{{anchor}}</option>
      </select>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.opacity' | translateHs }}:</div>
    <div class="p-1 w-75">
      <input type="range" class="w-100" step="0.05" min="0" max="1" name="hs-icon-symbolizer-opacity"
        [(ngModel)]="symbolizer.opacity" (change)="emitChange()" />
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.size' | translateHs }}:</div>
    <div class="p-1 w-75">
      <input type="range" class="w-100" step="0.2" min="0.1" max="10" name="hs-icon-symbolizer-size"
        [(ngModel)]="symbolizer.size" (change)="emitChange()" />
    </div>
  </div>

  <div class="d-flex flex-row" *ngIf="symbolizer.offset !== undefined">
    <div class="p-1 w-25 mt-2">{{'STYLER.anchorX' | translateHs }}:</div>
    <span class="badge bg-warning mt-2" [title]="'STYLER.warningAttribNotStoredNotVisualized' | translateHs  ">!</span>
    <div class="p-1 w-75">
      <input type="range" class="w-100" step="0.05" min="-1.0" max="1.0" [name="hs-icon-symbolizer-offset-0"
        [(ngModel)]="symbolizer.offset[0]" *ngIf="symbolizer.offset !== undefined" (change)="emitChange()" />
    </div>
  </div>


  <div class="d-flex flex-row" *ngIf="symbolizer.offset !== undefined">
    <div class="p-1 w-25 mt-2">{{'STYLER.anchorY' | translateHs }}:</div>
    <span class="badge bg-warning mt-2" [title]="'STYLER.warningAttribNotStoredNotVisualized' | translateHs  ">!</span>
    <div class="p-1 w-75">
      <input type="range" class="w-100" step="0.05" min="-1.0" max="1.0" name="hs-icon-symbolizer-offset-1"
        [(ngModel)]="symbolizer.offset[1]" *ngIf="symbolizer.offset !== undefined" (change)="emitChange()" />
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.rotation' | translateHs }}:</div>
    <div class="p-1 w-75">
      <input type="range" class="w-100" step="1" min="0" max="360" name="hs-icon-symbolizer-rotate"
        [(ngModel)]="symbolizer.rotate" (change)="emitChange()" />
    </div>
  </div>
</form>